import React from 'react'
import { Accordion, AccordionDetails, AccordionSummary, Stack, Typography } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { HOLIDAYS_RADIUS } from '@/src/utils/holidays'

interface HolidayFaqProps {
    items: Array<{ question: string; answer: string }>
    expandedId: string | null
    onToggle: (id: string) => void
    isMobile: boolean
}

const HolidayFaq: React.FC<HolidayFaqProps> = ({ items, expandedId, onToggle, isMobile }) => {
    return (
        <Stack spacing={1}>
            {items.map(item => (
                <Accordion
                    key={item.question}
                    disableGutters
                    elevation={0}
                    expanded={expandedId === item.question}
                    onChange={() => onToggle(item.question)}
                    sx={{
                        border: '1px solid',
                        borderColor: 'borders.default',
                        borderRadius: HOLIDAYS_RADIUS.NESTED,
                        '&:before': { display: 'none' },
                        '&.Mui-expanded': { borderColor: 'primary.main' }
                    }}
                >
                    <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: 'textColors.subheading' }} />}>
                        <Typography
                            sx={{
                                fontSize: isMobile ? '0.875rem' : '0.938rem',
                                fontWeight: 600,
                                color: 'textColors.primary'
                            }}
                        >
                            {item.question}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ pt: 0 }}>
                        <Typography
                            sx={{
                                fontSize: isMobile ? '1rem' : '0.875rem',
                                lineHeight: 1.7,
                                color: 'textColors.secondary'
                            }}
                        >
                            {item.answer}
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            ))}
        </Stack>
    )
}

export { HolidayFaq }
export type { HolidayFaqProps }
export default HolidayFaq
